module.exports = __webpack_public_path__ + "img/Pt-studio.0a6ddac6.gif";